import { useState, useEffect } from "react";
import { CustomProperty } from "winslow-core";
import { EmployeeRecordSelect } from "../../shared/EmployeeRecordSelect";

type AppCustomPropertyEmployeeRecordProps = {
    customProperty: CustomProperty;
    data: any;
    validate: boolean
    onChange: (label: string, data: any) => void;
}

export const AppCustomPropertyEmployeeRecord = ({customProperty, data, validate, onChange} : AppCustomPropertyEmployeeRecordProps) => {

    const [value, setValue] = useState<string>(data as string || "");

    useEffect(() => {
        onChange(customProperty.label, value);
    }, [value]);

    return (
        <div className="app-custom-property-employee-record">
            {/* <div className="app-custom-property-label">
                {customProperty.label}
            </div> */}
            <div className="app-custom-property-value">
               <EmployeeRecordSelect 
                    selected={data}
                    onChange={(value: any) => {
                        console.log("Manager: ", value);
                        onChange(customProperty.label, value);
                    }}
                />
            </div>
        </div>
    )
}
